import * as Diagram from "../../../../components/diagram";

export const ElderlyHealthAssessmentList = {
  label: "老人健康評估清冊",
  key: "ElderlyHealthAssessmentList",
  path: "ElderlyHealth/ElderlyHealthAssessmentList",
  api: "TCS_V_ElderlyHealthAssessmentList",
  render: (options) => (
    <Diagram.ElderlyHealth.ElderlyHealthAssessmentList {...options} />
  ),
  isRaw: true,
  isPage: true,
  dateRangeColumns: [{ label: "填寫日期", key: "2568" }],
  columns: [
    { key: "2568", field: "2568", header: "填寫日期" },
    { key: "2567", field: "2567", header: "填寫人" },
    { key: "Phone", field: "Phone", header: "電話" },
    { key: "Mobile", field: "Mobile", header: "手機" },
    { key: "RegionName", field: "RegionName", header: "戶籍鄉名" },
    { key: "Address", field: "Address", header: "現居地址" },
    { key: "Name", field: "Name", header: "姓名" },
    { key: "GenderCategoryName", field: "GenderCategoryName", header: "性別" },
    { key: "PID", field: "PID", header: "身分證號" },
    { key: "Birthday", field: "Birthday", header: "出生年月日" },
    {
      key: "HouseEnvironmentName",
      field: "HouseEnvironmentName",
      header: "居住狀況",
    },
    {
      key: "ForeignCaregiverName",
      field: "ForeignCaregiverName",
      header: "外籍看護工",
    },
    { key: "2557", field: "2557", header: "自覺健康狀況" },
    { key: "2558", field: "2558", header: "慢性疾病" },
    { key: "2624", field: "2624", header: "癌症" },
    { key: "2561", field: "2561", header: "自覺日常生活自我照顧能力" },
    { key: "2583", field: "2583", header: "進食" },
    { key: "2584", field: "2584", header: "洗澡" },
    { key: "2585", field: "2585", header: "個人衛生" },
    { key: "2586", field: "2586", header: "穿脫衣服" },
    { key: "2587", field: "2587", header: "排便控制" },
    { key: "2588", field: "2588", header: "排尿控制" },
    { key: "2589", field: "2589", header: "如廁" },
    { key: "2590", field: "2590", header: "移位(輪椅與床位間的移動)" },
    { key: "2591", field: "2591", header: "步行" },
    { key: "2592", field: "2592", header: "上下樓梯" },
    { key: "2595", field: "2595", header: "上街購物" },
    { key: "2596", field: "2596", header: "外出活動" },
    { key: "2597", field: "2597", header: "食物烹調" },
    { key: "2598", field: "2598", header: "家務維持" },
    { key: "2599", field: "2599", header: "洗衣服" },
    { key: "2600", field: "2600", header: "使用電話的能力" },
    { key: "2601", field: "2601", header: "服用藥物" },
    { key: "2602", field: "2602", header: "處理財務能力" },
    {
      key: "2605",
      field: "2605",
      header: "體重減輕-與1年前相比體重減少超過3公斤。(過去一年中未刻意減重)",
    },
    {
      key: "2606",
      field: "2606",
      header:
        "下肢功能-無法在不用支撐下，從椅子站起來5次(應於15秒內完成)。1.測試期間請保持兩手抱胸姿勢。2.如有使用柺杖或助行器者，直接勾選“是”。",
    },
    {
      key: "2607",
      field: "2607",
      header:
        "精神降低-在過去一週內，是否經常(一個禮拜內有3天以上) 有提不起勁來做事的感覺。",
    },
    {
      key: "2610",
      field: "2610",
      header:
        "判斷力上的困難: 例如落入圈套或騙局、財務上不好的決定、買了對受禮者不合宜的禮物",
    },
    { key: "2611", field: "2611", header: "對活動和嗜好的興趣降低" },
    { key: "2612", field: "2612", header: "重複相同的問題、故事和陳述" },
    {
      key: "2613",
      field: "2613",
      header:
        "在學習如何使用工具、設備、和小器具上有困難。例如: 電 視、音響、冷氣機、洗衣機、熱水爐(器)、微波爐、遙控器",
    },
    { key: "2614", field: "2614", header: "忘記正確的月份和年份" },
    {
      key: "2615",
      field: "2615",
      header:
        "處理複雜的財務上有困難。例如:個人或家庭的收支平衡、所得稅、繳費單",
    },
    { key: "2616", field: "2616", header: "記住約會的時間有困難" },
    { key: "2617", field: "2617", header: "有持續的思考和記憶方面的問題" },
    { key: "2625", field: "2625", header: "備註內容" },
  ],
};
